import React from 'react';
import HelperDate from '../../Helper/HelperDate';

const AnulacaoHistorico = ({ anulacoes }) => {

    console.log(anulacoes.length)

    return (
        <div>
            <div className="topo-dados_diploma-historico col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                {
                    anulacoes?.map((anulacao, idx) =>
                        <div key={idx} className={`dados_diploma-anulado ${!anulacao.ativo && 'historico'}`}>

                            {
                                idx === 0 &&
                                <div className="topo-card-historico">Última atualização</div>
                            }

                            {
                                anulacao.ativo ?
                                    <>
                                        Este Diploma foi revogado pelo motivo de
                                        <span className="motivo-anulado">
                                            {' '}{anulacao.ocorrencia}
                                        </span>.
                                        Sua revogação se deu no dia 
                                        <span className="dia-anulado">
                                            {' '}{HelperDate.formatDate(anulacao.dataCadastro)}
                                        </span>.
                                        <br></br>
                                        Este Diploma está anulado de forma 
                                        <span id="irreversivel-anulado">
                                            {' '}{anulacao.irreversivel ? 'irreversível' : 'temporária'}
                                        </span>.
                                        <br></br>
                                        <span>
                                            Para ter acesso ao DIPLOMA DIGITAL vigente, solicite ao discente o novo código de acesso                                            
                                        </span>.
                                    </>
                                    :
                                    <>
                                        Este Diploma foi anulado de forma temporária do dia
                                        <span className="dia-anulado">{' '}{HelperDate.formatDate(anulacao.dataCadastro)}</span>
                                        , até o dia <span className="dia-anulado">{' '}{HelperDate.formatDate(anulacao.dataSuspensao)}</span>.
                                        <br></br>Sua anulação, neste período, ocorreu devido
                                        <span className="motivo-anulado">{' '}{anulacao.ocorrencia}</span>.
                                    </>
                            }
                        </div>
                    )
                }

            </div>
        </div>
    );
};

export default AnulacaoHistorico;